import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function fetchDocumentDetails(payload) {
  try {
    const url = paths.fetchDocumentDetails();
    const response = await axiosInstance.post(url, payload);

    if (response?.data?.status === 200 && response?.data?.data) {
      return response.data;
    }

    throw new Error(response?.data?.errorMessage || "User not found");
  } catch (error) {
    throw new Error(
      error?.response?.data?.errorMessage || "Error fetching user details."
    );
  }
}

const useFetchDocumentDetails = () => {
  return useMutation({
    mutationFn: fetchDocumentDetails,
  });
};

export { useFetchDocumentDetails };
